import en from './locales/en.json';
import ko from './locales/ko.json';
import cn from './locales/cn.json';
import { createI18n } from 'vue-i18n'

// const lang: string = localStorage.getItem('LOCALE_LANGUAGE') ?? navigator.language.slice(0, 2);
let locale = localStorage.getItem("LOCALE_LANGUAGE");
if (!locale) {
  if (navigator.language) {
    locale = navigator.language.slice(0, 2);
    if (locale !== 'ko' && locale !== 'en' && locale !== 'cn') {
      locale = 'ko';
    }
  } else {
    locale = 'ko';
  }
}

export default createI18n({
  locale,
  globalInjection: true,
  messages:{
    'en-US': en,
    'en': en,
    'ko': ko,
    'cn': cn,
  },
});